<template>
  <v-card>
    <user-permissions-tag-table-dialog />
    <v-data-table
        :headers="headers"
        :items="allUserTableList"
        :items-per-page="20"
        class="elevation-1"
        :loading="loading"
        loading-text="Loading users"
        :options.sync="options"
    >

      <template v-slot:item.edit="{ item }">
        <v-btn
            icon
            color="primary"
            :to="{name: 'user-view', params: {id: item.id}}"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {mapState} from "vuex";
import UserPermissionsTagTableDialog from "@/components/user-permissions/UserPermissionsTagTableDialog";

export default {
  name: "UserPermissionTableCard",
  components: {
    'user-permissions-tag-table-dialog': UserPermissionsTagTableDialog
  },
  data() {
    return {
      getFirstUsers: [],
      options: this.tableOptions,
      search: null,
      footerProps: {"items-per-page-options": [20, 50, 100, 500]},
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        {
          text: 'Email',
          align: 'center',
          sortable: false,
          value: 'email',
        },
        {
          text: 'Role',
          align: 'center',
          sortable: false,
          value: 'role',
        },
        {
          text: 'Tags',
          align: 'center',
          sortable: false,
          value: 'tags',
        },
        {
          text: '',
          align: 'end',
          sortable: false,
          value: 'edit',
        },
      ],
    }
  },
  computed: {
    ...mapState('userPermissions', ['loading', 'allUserTableList'])
  },

}
</script>

<style scoped>

</style>